<template>
    <ClientOnly>
        <DnAccordion
            :id="slugify(title).toLowerCase()"
            ref="accordion"
            :items="[items]"
            :scroll-into-view="false"
            :scroll-smooth="true"
            class="base-accordion"
            :open-indexes="isDesktop ? [0] : []"
        >
            <template #title>
                <h4 @click="handleAccordionClick(title)">
                    {{ title }}
                </h4>
            </template>


            <template #default>
                <FlexibleSections
                    :sections="Array.isArray(items) ? items : []"
                    :full-width="true"
                />
            </template>

            <template #icon>
                <BaseIcon
                    icon="chevron-down"
                    :style="{
                        opacity: isDesktop ? 0.5 : 1,
                    }"
                    @click="handleAccordionClick(title)"
                />
            </template>
        </DnAccordion>
    </ClientOnly>
</template>

<script setup>
import DnAccordion from '@digitalnatives/accordion';
import BaseIcon from '~/components/BaseIcon/BaseIcon.vue';
import slugify from 'slugify';
import {useIsDesktop} from '~/composables/useIsDesktop';

const isDesktop = useIsDesktop();

defineProps({
    title: {
        type: String,
        required: true,
    },
    items: {
        type: Array,
        required: true,
        default() { return []; }
    }
});
const { trackEvent } = useCustomGtmEvent();

const { pageType } = inject('pageType');

const handleAccordionClick = (title) => {
    trackEvent({
        event: 'accordion_click',
        'page_type': pageType?.value,
        'accordion_text': title
    });
};
</script>
